import React from 'react';
import Lottie from 'react-lottie';

import { Animations } from '~/assets';

const Loading = ({ height = 357, width = 357 }) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: Animations.Loading,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return <Lottie options={defaultOptions} height={height} width={width} isClickToPauseDisabled />;
};

export default Loading;
